import { createSelector } from 'reselect'

import { selectEmrVersionConfig } from 'selectors/selectEmrVersionConfig'

export const selectDefaultInstanceFleets = createSelector(
  [selectEmrVersionConfig],
  (emrVersionConfig) => emrVersionConfig.get('default_instancefleet_instances')
)
